<template>
  <label class="search-form-fieldset">
    <span class="search-form-fieldset__label">{{ label }}</span>
    <span class="search-form-fieldset__data">
      <span class="search-form__select">
        <select
          :name="inputName"
          v-model="selectValue"
        >
          <option
            v-for="(data, i) in optionsList"
            :key="`option${i}`"
            :value="data.value"
            v-text="data.label"
            :selected="data.value === selectValue"
          />
        </select>
      </span>
    </span>
  </label>

</template>

<script>
import {defineComponent, computed} from 'vue'

export default defineComponent({
  name: 'SelectFormParts',
  props: {
    label: {
      type: String,
      default: '',
      required: true,
    },
    inputName: {
      type: String,
      default: '',
      required: true,
    },
    options: {
      type: Array,
      default: () => [],
      required: true,
    },
    value: {
      type: String,
      default: '',
      required: true,
    },
  },
  setup(props, context) {
    const optionsList = computed(() => props.options)
    const selectValue = computed({
      get: () => props.value,
      set: (val) => {
        return context.emit('changeInput', val)
      },
    })

    return {
      optionsList,
      selectValue,
    }
  },
})

</script>